module.exports = "<li :class=\"{'weui_uploader_file': true, 'weui_uploader_status': hasStatus}\" :style=\"{'backgroundImage': 'url(' + imageUrl + ')'}\">\n  <div class=\"weui_uploader_status_content\">\n    <slot name=\"status\"></slot>\n  </div>\n</li>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/uploader/uploader-file.vue
 ** module id = 132
 ** module chunks = 0
 **/